import { addBreadcrumb } from '@sentry/react';
import { useEffect } from 'react';

const useVisibilityChangeDetection = () => {
  useEffect(() => {
    const onVisibilityChange = () => {
      addBreadcrumb({
        category: document.hidden ? 'visibility.hidden' : 'visibility.visible',
        level: 'info',
      });
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);
};

export default useVisibilityChangeDetection;
